import React from "react";
import { useNavigate } from "react-router-dom";
import TextInput from "../../../../components/elements/forms/TextInput";
import SubmitButton from "../../../../components/elements/forms/SubmitButton";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { useRegister } from "../../misc/useAdminRegister";
import { useAppSelector, useAppDispatch } from "../../../../store/hooks";
import { clearMessage } from "../../../../store/slices/message";
import ModalSuccess from "../../../../components/Modal/ModalSuccess";
import { useOrganizationData } from "../../../../services/api/settings";

const CreateAdmin: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [show, showSet] = React.useState<"password" | "text">("password");
  const message = useAppSelector(({ message }) => message.message);
  const status = useAppSelector(({ message }) => message.status);
  const { organizationData } = useOrganizationData();
  const organizationId = organizationData?.id;
  // console.log("Org Data::", organizationData?.id);
  const { data, error, loading, onChangeHandler, onSubmit } = useRegister(
    organizationId!
  );
  console.log("Data Sent::", data);

  return (
    <div className="w-full py-5">
      <div className="max-w-[1096px] mx-auto px-3">
        <div className="flex border-b border-border text-20 pt-3">
          <div
            onClick={() => navigate(`/settings/profile`)}
            className="pb-1 cursor-pointer md:mr-8 mr-5"
          >
            <p className="font-[400]">Profile</p>
          </div>
          <div
            onClick={() => navigate(`/settings/admin/create`)}
            className={`border-b-[3px] border-secondary pb-1 cursor-pointer md:mr-8 mr-5`}
          >
            <p className="font-[400]">Create Admin</p>
          </div>
          <div
            onClick={() => navigate(`/settings/admin`)}
            className="pb-1 cursor-pointer md:mr-8 mr-5"
          >
            <p className="font-[400]">Admins</p>
          </div>
          <div
            onClick={() => navigate(`/settings/change-password`)}
            className="pb-1 cursor-pointer"
          >
            <p className="font-[400]">Change Password</p>
          </div>
        </div>
        <div className="rounded-10 bg-white px-4 py-4 w-[100%] mt-5">
          <div className="grid grid-cols-2 gap-3">
            <TextInput
              label="Email"
              placeholder="johndoe@email.com"
              name="email"
              status={error.email}
              value={data.email}
              onChange={onChangeHandler}
              // onBlur={onCheckEmail}
              className="cursor-wait"
            />
            <TextInput
              label="Password"
              placeholder="Password"
              name="password"
              status={error.password}
              value={data.password}
              onChange={onChangeHandler}
              type={show}
              right_icon={
                show === "text" ? (
                  <FaRegEyeSlash
                    size={20}
                    className="cursor-pointer"
                    onClick={() => showSet("password")}
                    color="#667185"
                  />
                ) : (
                  <FaRegEye
                    size={20}
                    className="cursor-pointer"
                    onClick={() => showSet("text")}
                    color="#667185"
                  />
                )
              }
            />
            <TextInput
              label="First Name"
              placeholder="John"
              name="firstName"
              status={error.firstName}
              value={data.firstName}
              onChange={onChangeHandler}
            />
            <TextInput
              label="Last Name"
              placeholder="Doe"
              name="lastName"
              status={error.lastName}
              value={data.lastName}
              onChange={onChangeHandler}
            />
          </div>
          <div className="max-w-[150px] mx-auto mt-4">
            <SubmitButton
              title="Create Admin"
              onSubmitHandler={onSubmit}
              loading={loading}
              className={`font-[400] text-white md:hover:bg-[white] md:hover:text-secondary hover:border-primary`}
            />
          </div>
          <ModalSuccess
            open={message ? true : false}
            btnText={status === "success" ? "Close" : "Renew Subscription"}
            link={
              status === "success" ? "/settings/admin" : "/subscriptions/renew"
            }
            onClose={() => dispatch(clearMessage())}
          ></ModalSuccess>
        </div>
      </div>
    </div>
  );
};

export default CreateAdmin;
